import { call, delay, put, takeEvery } from 'redux-saga/effects';
import {
  GET_TOTAL_RECOMMEND,
  getTotalRecommendAsync,
  GET_WORD_CLOUD,
  getWordCloudAsync,
  GET_POPULAR_CONTENTS,
  getPopularContentsAsync,
} from './actions';
import {
  apiGetTotalRecommend,
  apiGetWordCloud,
  apiGetPopularContents,
} from '../../lib/main/api';
import {
  GetTotalRecommendType,
  GetWordCloudType,
  GetPopularContentsType,
} from '../../lib/main/type';

function* getTotalRecommendSaga(
  action: ReturnType<typeof getTotalRecommendAsync.request>
) {
  try {
    yield delay(500);
    const response: GetTotalRecommendType = yield call(
      apiGetTotalRecommend,
      action.payload
    );
    yield put(getTotalRecommendAsync.success(response));
  } catch (error) {
    yield put(getTotalRecommendAsync.failure(error));
  }
}

function* getWordCloudSaga() {
  try {
    yield delay(500);
    const response: GetWordCloudType = yield call(apiGetWordCloud);
    yield put(getWordCloudAsync.success(response));
  } catch (error) {
    yield put(getWordCloudAsync.failure(error));
  }
}

function* getPopularContentsSaga() {
  try {
    yield delay(500);
    const response: GetPopularContentsType = yield call(apiGetPopularContents);
    yield put(getPopularContentsAsync.success(response));
  } catch (error) {
    yield put(getPopularContentsAsync.failure(error));
  }
}

export default function* tabMainSaga() {
  yield takeEvery(GET_TOTAL_RECOMMEND, getTotalRecommendSaga);
  yield takeEvery(GET_WORD_CLOUD, getWordCloudSaga);
  yield takeEvery(GET_POPULAR_CONTENTS, getPopularContentsSaga);
}
